import React from 'react';
import getRoutes from '../../../config/clientRoutes/getRoutes';
import { LoginPage, SsoPage } from '../../security/scenes';
import { Icons } from '../../shared/components';
import { lazyWithRetry } from 'src/modules/shared/helpers/lazyRetry';

const TeacherManual = lazyWithRetry(() => import('../../manuals/components/TeacherManual'));
const ContentPage = lazyWithRetry(() => import('../../contentPage/scenes/ContentPage'));
const ForgotPasswordPage = lazyWithRetry(() => import('../../security/scenes/ForgotPasswordPage'));
const ResetPasswordPage = lazyWithRetry(() => import('../../security/scenes/ResetPasswordPage'));
const CookieCompliancePage = lazyWithRetry(
  () => import('../../security/scenes/CookieCompliancePage')
);

export const publicRouteConfig = {
  login: {
    component: LoginPage,
  },
  sso: {
    component: SsoPage,
  },
  forgotPassword: {
    component: ForgotPasswordPage,
  },
  resetPassword: {
    component: ResetPasswordPage,
  },
  privacyPolicy: {
    component: () => (
      <ContentPage id="privacy-policy" autoHeight titleForceInline plainPage icon={Icons.INFO} />
    ),
  },
  termsOfUse: {
    component: () => (
      <ContentPage id="terms-of-use" autoHeight titleForceInline plainPage icon={Icons.INFO} />
    ),
  },
  cookieCompliance: {
    component: CookieCompliancePage,
  },
  vacature: {
    component: () => (
      <ContentPage id="vacature" autoHeight titleForceInline plainPage icon={Icons.INFO} />
    ),
  },
  teacherManual: {
    component: () => <TeacherManual />,
  },
};

const getPublicRoutes = getRoutes(publicRouteConfig);

export default getPublicRoutes;
